module.exports = __webpack_public_path__ + "static/media/bgDefaultCoursesTabletDay.4c8c37de.jpg";